import { Typography, Box, CircularProgress } from '@mui/material'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxInput from 'components/custom/AdxInput'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import { Field, Form, Formik } from 'formik'
import React, { forwardRef, useState } from 'react'
import { getNonActiveRun } from 'services/api/modules/payroll/payroll-dashboard'
import { useQuery } from 'react-query'

const PayrollPeriodModal = forwardRef((props, ref) => {
  const { setSelectValue, onRunPayroll } = props
  const {
    data: payrollPeriodData,
    // isLoading: loadingDropdown
  } = useQuery('nonActiveRun', getNonActiveRun)
  let payrollPeriod = payrollPeriodData?.data
  const [payrollPeriodOption, setPayrollPeriodOption] = useState([])
  const handleCallPeriodList = () => {
    setPayrollPeriodOption(payrollPeriod)
  }

  const handleRunPayroll = async (values) => {
    const { payrollPeriod } = values
    onRunPayroll(payrollPeriod)
  }

  return (
    <Formik
      innerRef={ref}
      enableReinitialize
      initialValues={{
        payrollPeriod: '',
      }}
      onSubmit={(values) => handleRunPayroll(values)}
    >
      {({ values, handleChange, handleBlur }) => {
        values && setSelectValue(values)
        return (
          <Form>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="subtitle1">Period</Typography>
                <Field
                  name="payrollPeriod"
                  as={AdxDropdown}
                  sx={{ width: 1 }}
                  onFocus={handleCallPeriodList}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  options={payrollPeriodOption}
                >
                  {payrollPeriodData === undefined ? (
                    <Box display="flex" justifyContent="center" alignItems="center">
                      <CircularProgress color="alternate" size={30} />
                    </Box>
                  ) : payrollPeriod?.length === 0 ? (
                    <Box px={2} py={1}>
                      <Typography color="light-gray-text.main">
                        There is no more payroll to be run this year
                      </Typography>
                    </Box>
                  ) : (
                    payrollPeriodOption?.map((item, index) => {
                      // let active = activePayroll.map(e => e.month).includes(item.month)
                      return (
                        <AdxMenuItem
                          selectedvalue={values.payrollPeriod}
                          key={index}
                          value={item}
                          disabled={item?.status === 1}
                        >
                          {`${item.value} ${item.year}`}
                        </AdxMenuItem>
                      )
                    })
                  )}
                </Field>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="subtitle1">Effective date</Typography>
                <Typography color="light-gray-text.main" marginBottom={2} textAlign="justify">
                  According to Section 19(1) of the Employment Act 1955, all employers must pay each
                  of their employees not later than the 7th day after the last day of any wage
                  period, which shall be deemed to be 1 month if no wage period is defined in the
                  contract (Section 18(2) of the Employment Act).
                </Typography>
                <AdxInput type="standard" value={values.payrollPeriod.effective_date} disabled />
              </Box>
            </Box>
          </Form>
        )
      }}
    </Formik>
  )
})

export default PayrollPeriodModal
